import { useList } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { Gestore } from "../types"

export function useGestoriList(params: Record<string, string> = {}) {
  return useList<Gestore>(`${API_URL}/gestori`, { query: params })
}
